"use client";
import Stack from "react-bootstrap/Stack";
import common from "../utils/common";
export function ColorColumnCell({
  color,
  text,
  diameter = "15px",
}: {
  color: string;
  text: string;
  diameter?: string;
}) {
  color = common.stringIsNullOrEmpty(color) ? "#ffffff" : color;
  text = common.stringIsNullOrEmpty(text) ? "N/A" : text;
  return (
    <Stack direction="horizontal" gap={2}>
      <div
        style={{
          backgroundColor: color,
          width: diameter,
          height: diameter,
          borderRadius: "50%",
          border: "1px solid #ccc",
        }}
      ></div>
      <>{text}</>
    </Stack>
  );
}
